import { routes as RKPageNames } from '@libs/renegkit/routes';

import { PageNames } from '@libs/acp/common/types/accessPermissions';

export const pageNames: PageNames = {
  home: {
    path: '/',
    type: 'public',
    name: 'Home',
  },
  signin: {
    path: '/login',
    type: 'public',
    name: 'Login',
  },
  testeIframe: {
    path: '/teste-iframe',
    type: 'public',
    name: 'teste - iframe',
  },
  signup: {
    path: '/cadastro',
    type: 'public',
    name: 'Cadastro',
  },
  signUpNCAD: {
    path: '/negociacao-simplificada',
    type: 'public',
    name: 'Negociação Simplificada',
  },
  signupNCADCompleted: {
    path: '/cadastro-ncad-completo',
    type: 'public',
    name: 'Cadastro NCAD Completo',
  },
  signUpPartnerCompleted: {
    path: '/cadastro-via-parceiro-completo',
    type: 'public',
    name: 'Cadastro via Parceiro Completo',
  },
  signupACPErrorKBA: {
    path: '/cadastro/erro-informacoes',
    type: 'public',
    name: 'Cadastro',
  },
  signupACPBlockedKBA: {
    path: '/cadastro/falha-ao-validar-informacoes',
    type: 'public',
    name: 'Cadastro',
  },
  signupACPBlockedLGPD: {
    path: '/cadastro/bloqueio-de-seguranca',
    type: 'public',
    name: 'Cadastro',
  },
  recoveryPasswordACPInvalidKBA: {
    path: '/recuperar-senha/erro-informacoes',
    type: 'public',
    name: 'Recuperar Senha',
  },
  recoveryPasswordACPBlockedKBA: {
    path: '/recuperar-senha/falha-ao-validar-informacoes',
    type: 'public',
    name: 'Recuperar Senha',
  },
  resetPasswordACPInvalidKBA: {
    path: '/redefinir-senha/erro-informacoes',
    type: 'public',
    name: 'Recuperar Senha',
  },
  resetPasswordACPBlockedKBA: {
    path: '/redefinir-senha/falha-ao-validar-informacoes',
    type: 'public',
    name: 'Recuperar Senha',
  },
  signinACPFailedDocument: {
    path: '/falha-ao-validar-documento',
    type: 'public',
    name: 'Login',
  },
  recoveryPassword: {
    path: '/recuperar-senha',
    type: 'public',
    name: 'Recuperar Senha',
  },
  redefinePassword: {
    path: '/redefinir-senha',
    type: 'public',
    name: 'Redefinir senha',
  },
  redefinePasswordLink: {
    path: '/redefinir-senha-link',
    type: 'public',
    name: 'Redefinir senha por link',
  },
  newPassword: {
    path: '/new-password',
    type: 'public',
    name: 'Cadastrar uma nova senha',
  },
  errorNoData: {
    path: '/cadastro/erro-faltando-informacoes',
    type: 'public',
    name: 'Erro No Data',
  },
  errorKba: {
    path: '/cadastro/erro-kba-limite',
    type: 'public',
    name: 'Error Kba',
  },
  errorKbaBigDataCorp: {
    path: '/cadastro/erro-kba-invalido',
    type: 'public',
    name: 'Error Kba Recovery Password',
  },
  account: {
    path: '/minha-conta',
    type: 'private',
    name: 'Minha conta',
    permissionsToAccess: ['all', 'customer'],
  },
  accountDeletion: {
    path: '/minha-conta/deletar-conta',
    type: 'private',
    name: 'Deletar conta',
    permissionsToAccess: ['all', 'customer'],
  },
  debts: {
    path: '/dividas',
    type: 'private',
    name: 'Dívidas',
    permissionsToAccess: ['all', 'reneg', 'reneg:read:agreements', 'reneg:feature:renegociate'],
  },
  myDebts: {
    path: '/minhas-dividas',
    type: 'private',
    name: 'Minhas dívidas',
    permissionsToAccess: [
      'all',
      'renegociate_debts',
      'read_debts',
      'reneg',
      'reneg:read:debts',
      'reneg:read:agreements',
      'reneg:feature:renegociate',
    ],
  },
  confirmation: {
    path: '/:partner/confirmacao',
    type: 'private',
    name: 'Confirmação',
    permissionsToAccess: ['all', 'renegociate_debts', 'reneg', 'reneg:feature:renegociate'],
  },
  agreementClosed: {
    path: '/:partner/acordo-fechado',
    type: 'private',
    name: 'Acordo Fechado',
    permissionsToAccess: ['all', 'renegociate_debts', 'reneg', 'reneg:feature:renegociate'],
  },
  agreementClosedError: {
    path: '/:partner/acordo-fechado/erro',
    type: 'private',
    name: 'Erro ao fechar o acordo',
    permissionsToAccess: ['all', 'renegociate_debts', 'reneg', 'reneg:feature:renegociate'],
  },
  billetNotFoundError: {
    path: '/boleto-nao-encontrado',
    type: 'private',
    name: 'Erro ao baixar o boleto',
    permissionsToAccess: ['all', 'reneg', 'reneg:feature:renegociate'],
  },
  offers: {
    path: '/ofertas',
    type: 'private',
    name: 'Ofertas',
    permissionsToAccess: ['all', 'credit'],
  },
  offerAnalysis: {
    path: '/analisando-oferta',
    type: 'private',
    name: 'Analisando Oferta',
    permissionsToAccess: ['all', 'credit'],
  },
  loans: {
    path: '/emprestimos',
    type: 'private',
    name: 'Simulador de Empréstimo',
    permissionsToAccess: ['all', 'credit'],
  },
  RKCheckoutPaymentPrefs: RKPageNames.checkoutPaymentPrefs, // TODO: remove after test
  RKCheckoutPaymentPrefsItau: RKPageNames.checkoutPaymentPrefsItau, // TODO: remove after test
  RKCheckoutClosedAgreement: RKPageNames.checkoutClosedAgreement, // TODO: remove after test
  RKHome: RKPageNames.home,
  RKMyAgreements: RKPageNames.myAgreements,
  RKAgreement: RKPageNames.agreement,
  RKAgreementConditions: RKPageNames.agreementConditions,
  RKAgreementComposition: RKPageNames.agreementComposition,

  negativeDebts: {
    path: '/dividas-negativas',
    type: 'private',
    name: 'Dívidas Negativadas',
    permissionsToAccess: [
      'all',
      'renegociate_debts',
      'read_debts',
      'reneg',
      'reneg:read:debts',
      'reneg:read:agreements',
      'reneg:feature:renegociate',
    ],
  },
  myScore: {
    path: '/monitoramento/financeiro',
    type: 'private',
    name: 'Financeiro',
    permissionsToAccess: ['all', 'score', 'score:read:score', 'score:read:positive_data'],
  },
  scoreKbaQuestions: {
    path: '/monitoramento/score',
    type: 'private',
    name: 'Score',
    permissionsToAccess: ['all', 'score', 'score:read:score', 'score:read:positive_data'],
  },
  scoreError: {
    path: '/monitoramento/erro',
    type: 'private',
    name: 'Score Error',
    permissionsToAccess: ['all', 'score', 'score:read:score', 'score:read:positive_data'],
  },
  accountCanceled: {
    path: '/conta-cancelada',
    type: 'public',
    name: 'Conta Cancelada',
  },
  details: {
    path: '/oferta-detalhada/:slug',
    type: 'private',
    name: 'Oferta Detalhada',
    permissionsToAccess: ['all', 'credit'],
  },
  contactUs: {
    path: '/fale-conosco',
    type: 'public',
    name: 'Fale Conosco',
  },
  updateEmail: {
    path: '/atualizar-email',
    type: 'private',
    name: 'Atualizar Email',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  updateEmailACP: {
    path: '/atualizar-contato/email',
    type: 'private',
    name: 'Atualizar Email',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  validateConflictingEmailACP: {
    path: '/validar-contato/email',
    type: 'private',
    name: 'Validar Email',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  publicEmailConfirmation: {
    path: '/confirmacao-de-email',
    type: 'public',
    name: 'Confirmar Email',
  },
  signinUnifyPasswordACP: {
    path: '/unificar-senha',
    type: 'private',
    name: 'Unificar Senha',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  updatePhoneACP: {
    path: '/atualizar-contato/telefone',
    type: 'private',
    name: 'Atualizar Telefone',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  updateSocialName: {
    path: '/atualizar-nome-social',
    type: 'private',
    name: 'Atualizar Nome Social',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  updateContactSuccess: {
    path: '/atualizar-contato/sucesso',
    type: 'private',
    name: 'Contato atualizado com sucesso',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  updatePasswordACP: {
    path: '/alterar-senha',
    type: 'private',
    name: 'Alterar Senha',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  updatePasswordSuccess: {
    path: '/alterar-senha/sucesso',
    type: 'private',
    name: 'Senha alterada com sucesso',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  unlockProtectedFeature: {
    path: '/validar-identidade',
    type: 'private',
    name: 'Validar identidade',
    permissionsToAccess: [
      'reneg',
      'reneg:read:debts',
      'reneg:read:agreements',
      'reneg:feature:renegociate',
      'score',
      'score:read:score',
      'score:read:hidden_score',
      'score:read:positive_data',
      'credit',
      'customer',
      'customer:read:data',
      'customer:write:data',
    ],
  },
  unlockProtectedFeatureSuccess: {
    path: '/validar-identidade/sucesso',
    type: 'private',
    name: 'Identidade validada com sucesso',
    permissionsToAccess: ['all'],
  },
  unlockProtectedFeaturePassword: {
    path: '/validar-identidade/recuperar-senha',
    type: 'private',
    name: 'Recuperar Senha',
    permissionsToAccess: [
      'score',
      'score:read:score',
      'score:read:hidden_score',
      'score:read:positive_data',
      'customer',
      'customer:read:data',
      'customer:write:data',
    ],
  },
  unlockProtectedFeatureACPInvalidKBA: {
    path: '/validar-identidade/recuperar-senha/erro-informacoes',
    type: 'private',
    name: 'KBA inválido',
    permissionsToAccess: ['all'],
  },
  unlockProtectedFeatureACPBlockedKBA: {
    path: '/validar-identidade/recuperar-senha/falha-ao-validar-informacoes',
    type: 'private',
    name: 'Falha ao validar informações',
    permissionsToAccess: ['all'],
  },
  notFound: {
    path: '/pagina-nao-encontrada',
    type: 'public',
    name: 'Página não encontrada',
  },
};

export const publicPagePaths = Object.keys(pageNames).reduce((acc: string[], curr: string) => {
  return pageNames[curr].type === 'public' ? acc.concat(pageNames[curr].path) : acc;
}, []);

export const privatePagePaths = Object.keys(pageNames).reduce((acc: string[], curr: string) => {
  return pageNames[curr].type === 'private' ? acc.concat(pageNames[curr].path) : acc;
}, []);

export const pagePaths = Object.keys(pageNames).map((key) => ({
  path: pageNames[key].path,
}));

export const isFullHeader = (pathname: string) =>
  [ '/inicio', '/minhas-dividas', '/dividas', '/meus-acordos', '/emprestimos', '/ofertas', '/monitoramento', '/minha-conta', '/oferta-detalhada'].some((path) =>
    pathname.includes(path)
  );

export const isSimpleHeader = (pathname: string) =>
  ['/acordo', '/confirmacao', '/condicoes', '/composicao', '/acordo/', '/acordo-fechado'].some((path) => pathname.includes(path));

export const isItauTemplate = (pathname: string) => ['/itau-rdhi/confirmacao', '/itau/confirmacao'].some((path) => pathname.includes(path));

export const isWithoutHeader = (pathname: string) =>
  [
    '/atualizar-contato/sucesso',
    '/atualizar-contato/telefone',
    '/atualizar-contato/email',
    '/atualizar-nome-social',
    '/alterar-senha/sucesso',
    '/alterar-senha',
    '/unificar-senha',
    '/validar-identidade',
  ].some((path) => pathname.includes(path));

export const isFullFooter = (pathname: string) =>
  ['/inicio', '/minhas-dividas', '/dividas', '/meus-acordos', '/ofertas', '/monitoramento/financeiro', '/oferta-detalhada', '/minha-conta', '/acordo'].some((path) =>
    pathname.includes(path)
  );
